module.exports = "<div *ngIf=\"globals.preferences.custom_slide\">\n    <div [innerHTML]=\"globals.preferences.custom_slide | safeHtml\">\n\n    </div>\n</div>"